/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.31/esri/copyright.txt for details.
*/
import{generateUID as s}from"../../../../core/uid.js";import{Object3DState as t}from"./basicInterfaces.js";class c{constructor(){this.uid=s()}}class r extends c{constructor(s){super(),this.highlightGroupName=s,this.channel=t.Highlight}}class e extends c{constructor(){super(...arguments),this.channel=t.MaskOccludee}}export{r as Object3DHighlightStateID,e as Object3DOccludeeStateID};
